"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Unknown = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 18 24" },
        react_1.default.createElement(react_native_svg_1.G, { id: "illustarations-and-Icons", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Icons", transform: "translate(-1167.000000, -1554.000000)" },
                react_1.default.createElement(react_native_svg_1.G, { id: "atom-/-icon-/-filled-/-chargepoint-/-unavailable", transform: "translate(1164.000000, 1554.000000)" },
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M20.1315471,5.13790231 C20.6883756,6.30820412 21,7.61771017 21,9 C21,13.9705627 14.0104874,24 12,24 C10.712406,24 7.38260606,19.8863081 5.15453769,15.6223748 Z M12,0 C14.50848,0 16.7772657,1.02625331 18.4094066,2.68180938 L3.88555754,12.849591 C3.33752095,11.4288436 3,10.0922762 3,9 C3,4.02943725 7.02943725,0 12,0 Z", id: "Combined-Shape", fill: color, "fill-rule": "nonzero" }))))));
};
Unknown.defaultProps = {
    color: '#9D9D9D',
    width: 18,
    height: 24,
};
exports.default = react_1.default.memo(Unknown);
